/**
 * Cinta permanente: «estos datos son de demostracion».
 *
 * Por que existe
 * --------------
 * La demo dejo de ser reconocible. La marca «de demostracion» que el seed
 * escribia en las observaciones se saco —con razon: se imprimia al pie de PDF
 * con importes reales que ya habian salido por mail—, y sin ella quedaron
 * consorcios con nombre y CUIT verosimiles, un padron de unidades con DNI y
 * comprobantes emitidos que se leen exactamente como datos del cliente. Alguien
 * que abre el sistema para conocerlo no tiene forma de saber que ese saldo es
 * inventado.
 *
 * Esta cinta dice lo mismo que decia el papel, pero **en la aplicacion y no en
 * los documentos**: los PDF siguen saliendo limpios, que es la condicion que no
 * se podia romper.
 *
 * Que NO es
 * ---------
 * No es un control de nada. Es un cartel. Lo enciende `Tenant.is_demo`, que pone
 * `seed_demo` y nadie mas: una organizacion real nunca lo trae, asi que en el
 * despliegue del cliente esto no se dibuja jamas.
 */

import { useSessionStore } from '@/store/session';

/** `true` si la organizacion activa esta marcada como de demostracion. */
export function usarOrganizacionDeDemo(): boolean {
  return useSessionStore((estado) => estado.tenant?.demo === true);
}

export function AvisoDemo() {
  const esDemo = usarOrganizacionDeDemo();
  if (!esDemo) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 border-b border-warning/40 bg-warning-soft px-4 py-1.5 text-center text-xs"
    >
      <strong className="font-semibold">Datos de demostración.</strong>
      <span className="text-fg-muted">
        Los consorcios, los administradores, las ventas y los saldos de esta organización son
        inventados: sirven para probar el sistema, no son de nadie.
      </span>
    </div>
  );
}
